<template>
    <div class="card">
      <header>
        <p class="name">{{ getCurSessionNickName() }}</p>
      </header>
    </div>
    <!-- <a-button type="link" @click="showEditNameModal">
      <EditOutlined />编辑联系人
    </a-button> -->
    <EditNameModal
    v-model:visible="editNameModalVisible"
  />
  </template>
  
 
  <script lang="ts" setup>
  import { useStore } from 'vuex';
  import { computed,onMounted } from 'vue';
  import EditNameModal from "../EditNameModal.vue";
  import { debounce } from 'lodash'; // 确保安装了 lodash
  import { ref } from 'vue';
  import {
  EditOutlined,
} from "@ant-design/icons-vue";
  import { ExternalFun } from '../../ExternalFun';
  const editNameModalVisible = ref(false);
  const imageUrl = ref(null);
  // 定义接口 (类型)
  interface User {
    name: string;
    imgId: number;
  }

  interface Session {
    id: number;
    user: {
      name: string;
      imgId: number;
    };
    messages: any[]; // 可以定义 MessageItem 类型
  }
  
  
  // 使用 Composition API
  const store = useStore();
  
 
 const getCurSessionNickName = ()=>{
  let currentId = store.state.currentSessionId;
  let session = store.state.sessions.find((item) => item.id === currentId);
  if(session == undefined)
  {
     return ""
  }
  return session.user.name;

 }

 const showEditNameModal = () => {
   console.log("showEditNameModal");
   editNameModalVisible.value = true;
};


  // 搜索函数 (防抖处理)
  const onKeyup = debounce((value: string) => {
    store.commit('SET_FILTER_KEY', value); // 触发 mutation
  }, 150); // 150ms 防抖延迟
  
  // 本地 onKeyup 函数，用于处理 input 事件
  const handleKeyup = (e: Event) => { // KeyboardEvent -> Event
    const target = e.target as HTMLInputElement;
    onKeyup(target.value); // 调用防抖函数
  };

  onMounted(async () => {
 
  })  

 

  </script> 
  
  
  <style scoped lang="less">
  .card {
    padding: 12px;
    border-bottom: solid 1px #24272C;
  
    footer {
      margin-top: 10px;
    }
  
    .avatar,
    .name {
      vertical-align: middle;
    }
  
    .avatar {
      border-radius: 2px;
    }
  
    .name {
      display: inline-block;
      margin: 0 0 0 15px;
      font-size: 16px;
    }
  
 
  }
  </style>